<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, defineExpose } from "vue";
import { useRouter } from 'vue-router'
import mypageRecordService from "../../../services/mypage/mypageRecordService";
import adminUserService from "../../../../admin/services/user/adminUserService";
import mypageProposalService from "../../../services/mypage/mypageProposalService";
import Loading from 'vue3-loading-overlay';
import MyPageResumeModalBody from "../mypage/MyPageResumeModalBody.vue";
import {useMyPageLectDetailStore} from "../../../stores/mypage/mypageLectDetailStore";
import mypageUserResumeService from "../../../services/mypage/mypageUserResumeService";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import { useUserStore } from "../../../stores/user";
import { storeToRefs } from "pinia";

const router = useRouter();
const loadingStore = usePageLoadingStore()
const lectureStore = useMyPageLectDetailStore()
const { isAdmin } = storeToRefs(useUserStore())

const baseModal = ref(null);
const resolvePromise = ref(null);

const modalBody = ref(null)
const alertModal = ref(null)
const confirmModal = ref(null)
const modalContent = ref([])
const okButtonText = ref("네");
const cancelButtonText = ref("아니오");

const loaded = ref(false)

const showButtons = ref(false)
const showPropButtons = ref(false)
const resumeLikeTxts = ref("♡관심인재");
const disabledCorpYns = ref(false);
const resumeLikeYns = ref(0)
const resumeIds = ref(0)

const userInfo = ref({});

const mode = ref("mypage")

const recordCopy = ref({})
const interests = ref("")

// 인쇄 대상 영역 참조
const printArea = ref(null)

// 모달 내용 인쇄
const onClickPrint = () => {
  try {
    const printContents = printArea.value?.innerHTML || "";
    const printWindow = window.open("", "", "width=900,height=700");
    if (!printWindow) {
      console.warn("Print window blocked");
      return;
    }
    printWindow.document.write(`
      <html>
        <head>
          <title>${userInfo.value.userName}의 이력서</title>
          <meta charset="utf-8" />
          <style>
            html, body { margin: 0; padding: 0; }
            body { margin: 20px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans KR", Arial, sans-serif; color: #111; }
            .print-container { width: 100%; }
            img { max-width: 100%; height: auto; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #e5e5e5; padding: 8px; }
            @page { size: auto; margin: 12mm; }
            @media print { .no-print { display: none !important; } }

            /* 인쇄용 이력서 스타일 (SCSS -> CSS 변환) */
            .resume-wrap { background-color: #F8F8FA; padding: 30px; }
            .resume-wrap .resume-title {
              width: 100%; overflow: hidden; text-overflow: ellipsis;
              border-bottom: 2px solid #121212; font-size: 30px; line-height: 50px;
              font-weight: bold; text-align: center; padding: 0 20px 20px; margin-bottom: 20px;
            }
            .resume-wrap .self-info { border-bottom: 2px solid #121212; }
            .resume-wrap .self-info h1 { font-size: 20px; line-height: 28px; margin-bottom: 10px; }
            .resume-wrap .self-info p { font-size: 16px !important; line-height: 22px !important; margin-bottom: 20px; }
            .resume-wrap .self-info p span { position: relative; margin-left: 20px; padding-left: 20px; }
            .resume-wrap .self-info p span:before {
              content: ""; position: absolute; top: 50%; left: 0; width: 1px; height: 14px;
              background: #E7E7E8; -webkit-transform: translateY(-50%); transform: translateY(-50%);
            }
            .resume-wrap .self-info p span:first-child { padding: 0; margin: 0; }
            .resume-wrap .self-info p span:first-child:before { display: none; }

            .resume-wrap section { border-bottom: 1px solid #121212; padding: 30px 0; }
            .resume-wrap section:last-child { border-bottom: 0; padding: 30px 0; }
            .resume-wrap section.basic div { border-top: 1px solid #E7E7E8; padding-top: 30px; }
            .resume-wrap section.basic div h2 { margin-bottom: 10px; }
            .resume-wrap section.basic div p { word-break: break-word; }
            .resume-wrap section.army h2 { color: #121212; }
            .resume-wrap section h2 { font-size: 16px !important; line-height: 30px !important; margin-bottom: 20px; }
            .resume-wrap section dl { display: flex; margin-bottom: 20px; }
            .resume-wrap section dl:last-child { margin-bottom: 0; }
            .resume-wrap section dl dt { width: 192px; color: #86889A; font-size: 14px; }
            .resume-wrap section dl dt.lang-tit { padding-top: 18px; }
            .resume-wrap section dl dt b { display: block; color: #121212; margin-bottom: 6px; }
            .resume-wrap section dl dd { width: calc(100% - 192px); font-size: 14px; }
            .resume-wrap section dl dd b { display: block; margin-bottom: 6px; }
            .resume-wrap section dl dd p span { position: relative; padding-left: 10px; margin-left: 10px; }
            .resume-wrap section dl dd p span:before {
              content: ""; position: absolute; top: 50%; left: 0; width: 1px; height: 10px;
              background: #E7E7E8; -webkit-transform: translateY(-50%); transform: translateY(-50%);
            }
            .resume-wrap section dl dd .file { color: #10117E; cursor: pointer; }
            .resume-wrap section div { padding-bottom: 20px; border-bottom: 1px solid #E7E7E8; }
            .resume-wrap section div:last-child { border-bottom: 0; padding-bottom: 0; }
            .resume-wrap section div h3 {
              font-size: 18px !important; line-height: 30px !important; color: #86889A;
              margin-top: 20px; margin-bottom: 6px;
            }
          </style>
        </head>
        <body>
          <div class="print-container">
              ${printContents}
           </div>
          <script>
            window.onload = function() {
              setTimeout(function(){
                window.print();
              }, 100);
            };
            window.onafterprint = function(){ window.close(); };
          <\/script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } catch (e) {
    console.error(e);
  }
}

// 마이페이지 이력서 보기
// userId가 있으면 해당인원, 없으면 로그인한 계정
const retrieveRecordDetail = (userId) => {
  loaded.value = false;
  mode.value = "mypage";
  if(userId) {
    let paramObj = {
      userId: userId,
      propId: 0,
      hidden: 0,
    }
    adminUserService.retrieveUserMyPage(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            console.log(result);
            modalBody.value.setHidden(0);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests;
            userInfo.value = result;
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    mypageRecordService.retrieveRecord()
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            console.log(result);
            modalBody.value.setHidden(0);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests;
            userInfo.value = result;
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  }
}

// 기업 마스터쪽에서 이력서 조회. hidden 1
// userId가 있으면 해당인원, 없으면 로그인한 계정
const retrieveMatchingRecordDetail = (userId, propId) => {
  loaded.value = false;
  mode.value = "mypage";
  if(userId !== undefined && propId !== undefined) {
    let paramObj = {
      userId: userId,
      propId: propId,
      hidden: 1,
    }
    adminUserService.retrieveUserMyPage(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            console.log(result);
            modalBody.value.setHidden(1);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    console.log('USER ID가 없습니다.')
  }
}

// 수강신청이력서 보기
const retrieveUserLectureRecordDetail = (userId, lectId, regDt) => {
  loaded.value = false;

  mode.value = "userLecture";
  const lecture = {
    "userId" : userId,
    "lectId" : lectId,
    "regDt" : regDt
  }
  lectureStore.setLecture(lecture)

  if(userId && lectId && regDt) {
    adminUserService.retrieveUserLectureMypage(userId, lectId, regDt)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            console.log(result);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    $toast('', '새로고침 후 다시 실행해주세요.');
  }
}

// 입사지원이력서 보기
const retrieveUserMatchingResumeDetail = (resumeId, hidden) => {
  loaded.value = false;
  resumeIds.value = resumeId;

  if(resumeId) {
    let paramObj = {
      resumeId: resumeId,
      hidden: hidden,
    }
    mypageUserResumeService.retrieveMatchingResume(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            console.log(result);
            modalBody.value.setHidden(hidden);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    $toast('', '새로고침 후 다시 실행해주세요');
  }
}

// 이력서 수정 버튼. 새창으로 열기
const onClickChangeResume = () => {
  router.push({ name: 'UserMatchingResume', query : { mode: mode.value }})
}

// 이력서 전송 버튼. 완료 후 입사지원현황 페이지로 이동
const onClickSendResume = () => {
  if (interests.value === null || interests.value === "") {
    modalContent.value = ["관심 카테고리를 선택하지 않았습니다.", "[이력서 수정]버튼을 눌러 관심 카테고리를 선택하세요."];
    alertModal.value.show();
  } else {
    confirmSendResume();
  }
}

// 이력서 전송
const confirmSendResume = async () => {
  modalContent.value = ["이력서를 기업에 전송할까요?", "전송 이후 인재 노출 희망을 Off하면 이력서는 비공개 됩니다."];
  okButtonText.value = "전송";
  cancelButtonText.value = "취소";
  const ok = await confirmModal.value.show();

  if ( ok ) { // 전송
    loaded.value = false;

    mypageUserResumeService.createResumeRecord ( recordCopy.value )
        .then((res) => {
          loaded.value = true;

          if(res.data.code.toLowerCase() === 'success') {
            router.push({ name: 'UserMatchingResumeProposalList'});
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {    // 취소

  }
}

// 채용 제안
const onClickResumeCorpYn = async (resumeId) => {
  modalContent.value = ["지원자에게 채용을 제안할까요?"];
  okButtonText.value = "채용 제안";
  const ok = await confirmModal.value.show();
  if(!ok) {
    return -1;
  } else {
    let paramObj2 = {
      resumeId: resumeId,
    }
    mypageProposalService.createResumeCorporationByResumeId(paramObj2)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            modalContent.value = ["채용을 제안하였습니다."];
            alertModal.value.show();
            disabledCorpYns.value = true;
            //$toast('', "채용을 제안하였습니다.")
          } else {
            modalContent.value = ["제안을 실패하였습니다."];
            alertModal.value.show();
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      modalContent.value = ["제안을 실패하였습니다."];
      alertModal.value.show();
      console.log(res);
    });
  }
}

// 관심 인재
const onClickResumeLikeYn = async (resumeId, yn) => {
  if(yn === 1) {
    modalContent.value = ["관심인재를 삭제하시겠습니까?"];
    okButtonText.value = "관심인재 삭제";
  } else {
    modalContent.value = ["관심인재를 등록하시겠습니까?"];
    okButtonText.value = "관심인재 등록";
  }
  const ok = await confirmModal.value.show();
  if(!ok) {
    return -1;
  } else {
    let paramObj3 = {
      resumeId: resumeId,
      likeState: yn,
    }
    mypageProposalService.changeResumeLikeByResumeId(paramObj3)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            modalContent.value = ["변경하였습니다."];
            alertModal.value.show();
            if(yn === 1) {
              resumeLikeTxts.value = "♡관심인재";
              resumeLikeYns.value = 0;
            } else {
              resumeLikeTxts.value = "♥관심인재";
              resumeLikeYns.value = 1;
            }
            //$toast('', msg+"을(를) 하였습니다.")
          } else {
            modalContent.value = ["변경을 실패하였습니다."];
            alertModal.value.show();
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      modalContent.value = ["변경을 실패하였습니다."];
      alertModal.value.show();
      console.log(res);
    });
  }
}

const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = async () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

const init = (showButton, showPropButton, resumeCorpYn, resumeLikeYn) => {
  // 기본값 저장
  //input.value.lectId = lectId;
  showButtons.value = showButton;
  showPropButtons.value = showPropButton;
  if(resumeLikeYn === 1) {
    resumeLikeTxts.value = "♥관심인재";
  } else {
    resumeLikeTxts.value = "♡관심인재";
  }

  if(resumeCorpYn === 1) {
    disabledCorpYns.value = true;
  } else {
    disabledCorpYns.value = false;
  }
  resumeLikeYns.value = resumeLikeYn;
}

defineExpose({
  show,
  init,
  retrieveRecordDetail,
  retrieveMatchingRecordDetail,
  retrieveUserLectureRecordDetail,
  retrieveUserMatchingResumeDetail,
})
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <loading
        :active="!loaded"
        loader="dots"
        color="#3843AF"
        opacity="0.5"
        width="35"
        :is-full-page="false"></loading>
  <div class="modal-inner xl-size">
    <button class="close" @click="cancel"></button>
      <div class="modal-body" v-show="loaded" ref="printArea">
        <MyPageResumeModalBody ref="modalBody"/>
      </div>
      <div v-if="!isAdmin && showButtons" class="modal-footer btn-wrap">
        <KSASecondaryButton text="이력서 수정" @click="onClickChangeResume" />
        <div class="modal-footer" style="margin-top: 0; padding: 0">
          <KSAPrimaryButton text="이력서 전송" @click="onClickSendResume" />
        </div>
      </div>
      <div v-if="isAdmin" class="modal-footer btn-wrap">
        <div class="modal-footer" style="margin-top: 0; padding: 0">
          <div class="mr-xs">
            <KSASecondaryButton text="인쇄" @click="onClickPrint" />
          </div>
        </div>
      </div>
      <div v-if="showPropButtons" class="modal-footer btn-wrap">
        <span data-title="관심 인재 : ">
          <KSASecondaryButton :text="resumeLikeTxts" @click="onClickResumeLikeYn(resumeIds, resumeLikeYns)" class="red_button"/>
        </span>
        <span data-title="채용 제안 : ">
          <KSAPrimaryButton text="채용 제안" :disabled="disabledCorpYns" @click="onClickResumeCorpYn(resumeIds)" />
        </span>
      </div>
    </div>
  </Modal>
  <AlertModal ref="alertModal" :content="modalContent" />
  <ConfirmModal ref="confirmModal" :content="modalContent" :okButtonText="okButtonText" :cancelButtonText="cancelButtonText" />

</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .modal-footer {
    padding: 0 30px;
  }
}

/* 인쇄 시 모달 컨트롤 숨김 */
@media print {
  .modal-footer { display: none !important; }
  .close { display: none !important; }
}
</style>